<template>
    <CardPage :section="7" :page="5" :nextDisabled="nextDisabled">
        <video controls controlslist="nodownload" @playing="playing" @ended="ended">
            <source :src="require('@/assets/videos/Video07.mp4')" type="video/mp4" />
            <track kind="captions" srclang="en" :src="require('@/assets/videos/Video07.vtt')" />
        </video>
    </CardPage>
</template>

<script>
export default {
    data() {
        return {
            videoStarted: false,
            videoCompleted: false
        };
    },
    methods: {
        nextDisabled() {
            return !(this.videoStarted && this.videoCompleted);
        },
        playing() {
            this.videoStarted = true;
        },
        ended() {
            this.videoCompleted = true;
        }
    }
};
</script>

<style scoped>
video {
    width: 100% !important;
    height: auto !important;
}
</style>
